import { startAppListening } from "../../../listener-middleware";
import { deliveryRevisionNudged, refetchChangedDelivery } from ".";
import * as selectors from "./selectors";

/**
 * Someone changed a delivery the dispatcher has open (the socket said so, or
 * the socket reconnected and may have missed it: `revision` null). Refetch it,
 * unless the revision is the one already loaded: then the change was the
 * dispatcher's own save, already in the store.
 *
 * While the dispatcher's own change to the delivery is on its way, the nudge
 * may be for that very change, and only its response says which revision that
 * is. So wait for it to come back before deciding.
 */
export const startDeliveriesListeners = () => {
  startAppListening({
    actionCreator: deliveryRevisionNudged,
    effect: async (action, api) => {
      const { deliveryId, revision } = action.payload;
      if (selectors.selectChangesInFlight(deliveryId)(api.getState()) > 0) {
        await api.condition(
          (_, state) => selectors.selectChangesInFlight(deliveryId)(state) === 0
        );
      }
      const delivery = selectors.selectDelivery(deliveryId)(api.getState());
      if (!delivery || (revision !== null && delivery.revision === revision)) {
        return;
      }
      await api.dispatch(refetchChangedDelivery(deliveryId));
    },
  });
};
